import { Pipe, PipeTransform } from '@angular/core';
import { bookAuthorModel } from '@shared/model/bookModels/book-model';

@Pipe({
    name: 'authorType',
})
export class AuthorTypePipe implements PipeTransform {
  author: authorNameType = new authorNameType();
  transform(bookAuthors: bookAuthorModel): authorNameType {
    this.author.name = bookAuthors.fullName || bookAuthors.name;
    let type = '';
    switch (bookAuthors.type) {
      case 'Author': {
        type = 'نویسنده';
        break;
      }
      case 'Editor': {
        type = 'ویراستار';
        break;
      }
      case 'Translator': {
        type = 'مترجم';
        break;
      }
      case 'Illustrator': {
        type = 'تصویرگر';
        break;
      }
      case 'Collector': {
        type = 'گردآورنده';
        break;
      }
      case 'Poet': {
        type = 'شاعر';
        break;
      }
      case 'UnderSupervision': {
        type = 'زیرنظر';
        break;
      }
      case 'GraphicDesigner': {
        type = 'گرافیست';
        break;
      }
      case 'Diligently': {
        type = 'به اهتمام';
        break;
      }
      case 'FilmEditor': {
        type = 'تدوین';
        break;
      }
      case 'Painter': {
        type = 'نقاش';
        break;
      }
      case 'Prepared': {
        type = 'تهیه و تنظیم';
        break;
      }
      case 'Calligrapher': {
        type = 'خطاط';
        break;
      }
      case 'Corrector': {
        type = 'مصحح';
        break;
      }
      case 'Preface': {
        type = 'مقدمه';
        break;
      }
      case 'Paraphraser': {
        type = 'بازنویسی';
        break;
      }
      case 'Producer': {
        type = 'تهیه کننده';
        break;
      }
      case 'Researcher': {
        type = 'محقق';
        break;
      }
      case 'Photographer': {
        type = 'عکاس';
        break;
      }
      case 'Designer': {
        type = 'طراح';
        break;
      }
      case 'Commenter': {
        type = 'شارح';
        break;
      }
      case 'InPartnership': {
        type = 'به همکاری';
        break;
      }
      case 'Tazhib': {
        type = 'مذهب';
        break;
      }
      case 'Essayist': {
        type = 'مقاله نویس';
        break;
      }
      case 'Adopter': {
        type = 'اقتباس گر';
        break;
      }
      case 'Summarizer': {
        type = 'تلخیص';
        break;
      }
      case 'Annotation': {
        type = 'حواشی';
        break;
      }
      case 'Responsible': {
        type = 'مسئول طرح';
        break;
      }
      case 'ToEnglishTranslator': {
        type = 'ترجمه انگلیسی';
        break;
      }
      case 'Cartoonist': {
        type = 'کاریکاتوریست';
        break;
      }
      case 'ToPoemTranslator': {
        type = 'ترجمه به شعر';
        break;
      }
      case 'Editing': {
        type = 'ویرایشگر';
        break;
      }
      case 'AdvisorsBoard': {
        type = 'هیئت مشاوران';
        break;
      }
      case 'Screenwriter': {
        type = 'فیلمنامه نویس';
        break;
      }
      case 'Reviewer': {
        type = 'نقد و بررسی';
        break;
      }
      case 'Director': {
        type = 'کارگردان';
        break;
      }
      case 'PrefaceTranslator': {
        type = 'ترجمه مقدمه';
        break;
      }
      case 'Composer': {
        type = 'آهنگساز';
        break;
      }
      case 'Notes': {
        type = 'یادداشت';
        break;
      }
      case 'Narrator': {
        type = 'گوینده';
        break;
      }
      case 'Musician': {
        type = 'نوازنده';
        break;
      }
      case 'Creator': {
        type = 'پدیدآور';
        break;
      }
    }
    this.author.type = type;
    return this.author;
  }

}

export class authorNameType {
  name?: string;
  type?: string;
}